import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { CsValueDebug } from "@plansoft-configuration-renderer/debug";
import { LayoutGridType } from "../ReactPageLayout/LayoutGridType";
import { LayoutRows } from "../ReactPageLayout/LayoutRows";
const gridContainerProps = {
    sx: { alignItems: "center" },
    rowSpacing: 0,
    columnSpacing: 0,
};
export function ControlCellChildren(props) {
    const { rows } = props;
    return (_jsxs(Fragment, { children: [_jsx(CsValueDebug, {}), _jsx(LayoutRows, { rows: rows, gridType: LayoutGridType.Control, gridContainer: gridContainerProps })] }));
}
//# sourceMappingURL=ControlCellChildren.js.map